module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"shop_the_look":"Shop the look"},"en":{"shop_the_look":"Shop this look"},"de":{"shop_the_look":"Shop the Look"},"es":{"shop_the_look":"Échale el guante a este look"},"it":{"shop_the_look":"Prova questo look"},"nl":{"shop_the_look":"Shop deze look"},"pt":{"shop_the_look":"Leve este estilo para casa"}}')
  delete Component.options._Ctor
}
